import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';

export default function ProductHomeTextImages() {
    return <div>
            <CcTitle>
                Personalised Images
            </CcTitle>
            <div className="text-ccColorDarkTeal">Turn your  CRM data into beautiful, eye-catching imagery with Personalised Images.</div>
            <Link to={`/workflow/9`} style={linkStyle}> 
                <CcCreateNewSnippet className="mt-4" >Create new Personalised Image</CcCreateNewSnippet>
            </Link>
            <div className=" mt-3 border border-gray-300 rounded-md p-1 flex flex-col gap-2">
                <CcSubSectionTitle>Start with existing Template</CcSubSectionTitle>
                <div>
                <TemplateGallery productTypeId={9} />
                </div>
            </div>

            <CcSubSectionTitle className=" mt-6">Latest Personalised Images Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={9}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}